import { render, staticRenderFns } from "./RelatorioCotasClienteListFiltroModalItemInput.vue?vue&type=template&id=12283a91"
import script from "./RelatorioCotasClienteListFiltroModalItemInput.vue?vue&type=script&lang=js"
export * from "./RelatorioCotasClienteListFiltroModalItemInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports